import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    // ======================
    // Full Layout
    // ======================
    path: "",
    component: () => import("./redesign/MainContainer.vue"),
    // ======================
    // Theme routes / pages
    // ======================
    beforeEnter: authorize,
    children: [
      {
        path: "/",
        name: "dashboard",
        index: 1,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/dashboard.vue"),
      },
      {
        path: "/daily-status",
        name: "Category",
        index: 2,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/dailyStatus.vue"),
      },
      {
        path: "/musicCategory",
        name: "Music",
        index: 201,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/musicCategory.vue"),
      },
      // {
      //   path: "/musiclistDisplay",
      //   name: "Music-List",
      //   index: 202,
      //   meta: { access: "MASTER" },
      //   component: () =>
      //     import("./views/components/calendar-admin/music-list.vue"),
      // },
      {
        path: "/musiclistDisplay/:catGuid",
        name: "music-list",
        index: 203,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/musicList.vue"),
      },
      // {
      //   path: "/musiclistDisplay/tag/:tagName",
      //   name: "music-list",
      //   index: 204,
      //   meta: { access: "MASTER" },
      //   component: () =>
      //     import("./views/components/calendar-admin/music-list.vue"),
      // },
      {
        path: "/horoscopePage",
        name: "Horoscope",
        index: 205,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/horoscope.vue"),
      },
      {
        path: "/accounts",
        name: "Accounts",
        index: 4,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/adminAccounts.vue"),
      },
      {
        path: "/account-form",
        name: "Accounts Forms",
        index: 41,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/account-form.vue"),
      },
      {
        path: "/logout",
        name: "Logout",
        index: 58,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/logout.vue"),
      },
      {
        path: "/edit-profile",
        name: "Edit Profile",
        index: 13,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/editProfile.vue"),
      },
      {
        path: "/language",
        name: "Language",
        index: 14,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/languageSettings.vue"),
      },
      {
        path: "/tag",
        name: "tag",
        index: 15,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/tags.vue"),
      },
      {
        path: "/post",
        name: "post",
        index: 16,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/posts.vue"),
      },
      {
        path: "/post/:catGuid",
        name: "post-by-catGuid", // Updated name
        index: 17,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/post.vue"),
      },
      {
        path: "/post/tag/:tagName",
        name: "post-by-tagName", // Updated name
        index: 18,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/post.vue"),
      },
      {
        path: "/user/:catId",
        name: "Users",
        index: 19,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/users.vue"),
      },
      {
        path: "/apps",
        name: "Apps",
        index: 20,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/apps.vue"),
      },
      {
        path: "/app-banners",
        name: "App Banners",
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/bannerScreens/appBanners.vue"),
        index: 220,
      },
      {
        path: "/web-banners",
        name: "Web Banners",
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/bannerScreens/webBanners.vue"),
        index: 221,
      },
      {
        path: "/shop-banners",
        name: "Shop Banners",
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/bannerScreens/shopBanners.vue"),
        index: 222,
      },
      {
        path: "/banners",
        name: "banner",
        index: 21,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/banner/mainSwitch.vue"),
      },
      {
        path: "/users",
        name: "users-list", // Updated name
        index: 22,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/users.vue"),
      },
      {
        path: "/contest",
        name: "Contest",
        index: 23,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/contest.vue"),
      },
      {
        path: "/participants",
        name: "Participants",
        index: 24,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/participants.vue"),
      },
      {
        path: "/offer",
        name: "Offer",
        index: 25,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/offers.vue"),
      },
      {
        path: "/eventcategory",
        name: "EventCategory",
        index: 26,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/eventCategory.vue"),
      },
      {
        path: "/events",
        name: "Events",
        index: 27,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/events.vue"),
      },
      {
        path: "/notification",
        name: "Notification",
        index: 28,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/notification.vue"),
      },
      {
        path: "/notificationSrv",
        name: "Notification Service",
        index: 29,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/appNotifications.vue"),
      },
      {
        path: "/articlecategory",
        name: "Article Category",
        index: 30,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/articleCategory.vue"),
      },
      {
        path: "/articles",
        name: "Articles",
        index: 31,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/articleList.vue"),
      },
      {
        path: "/articles/recent",
        name: "Recent Articles",
        index: 32,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/recentArticlesList.vue"),
      },
      {
        path: "/festival/",
        name: "Festival",
        index: 33,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/festivals.vue"),
      },
      {
        path: "/settings",
        name: "settings",
        index: 34,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/globalSettings.vue"),
      },
      {
        path: "/payments",
        name: "Payments",
        index: 35,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/paymentsScreen.vue"),
      },
      {
        path: "/consult-astrology",
        name: "Consult Astrology",
        index: 36,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/consult-astrology.vue"),
      },
      {
        path: "/bhakti-promotion",
        name: "Bhakti Promotion",
        index: 37,
        meta: { access: "MASTER" },
        component: () => import("./redesign/screens/bhaktiPromotion.vue"),
      },
      {
        path: "/calendar",
        name: "Calendar",
        index: 38,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/calendar.vue"),
      },
      {
        path: "/chats",
        name: "Chats",
        index: 39,
        meta: { access: "MASTER" },
        component: () => import("./views/components/calendar-admin/Chats/chats.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    index: 11,
    beforeEnter: unAuthorize,
    component: () => import("./views/Login.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    index: 12,
    beforeEnter: unAuthorize,
    component: () => import("./views/ForgotPassword.vue"),
  },
  {
    path: "/404-page-not-found",
    name: "NotFound",
    index: 177,
    component: () => import("./views/404.vue"),
  },
  {
    path: "/",
    name: "home",
    index: 179,
    component: () => import("./views/Home.vue"),
  },

  // Redirect to starterkit page, if no match found
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  fallback: true,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;

function authorize(to, from, next) {
  if (JSON.parse(localStorage.getItem("user")) != null) {
    if (to.meta.access != undefined && JSON.parse(localStorage.getItem("user")).token != undefined) {
      next();
      return;
    }
    // NO Restriction for admin
    // if (
    //   to.meta.access != undefined &&
    //   JSON.parse(localStorage.getItem("user")).masterToken != undefined
    // ) {
    //   next();
    //   return;
    // }
    router.push("/404-page-not-found");
    return;
  }
  localStorage.clear();
  router.push("/login");
}

function unAuthorize(to, from, next) {
  if (JSON.parse(localStorage.getItem("user")) == null) {
    next();
    return;
  }
  router.push("/alert");
}
